import activityTypes from "Constants/activityTypes";
import { sortBy } from "Libs/utils";

import type { ActivityFilterOptions } from "Constants/activityTypes";

const filteringOptions = sortBy(
  Object.keys(activityTypes).map(name => ({
    label: activityTypes[name].label,
    value: name
  })),
  "value"
) as ActivityFilterOptions;

export const filterOptions: ActivityFilterOptions = [
  { label: "show_all", value: "all_type" },
  ...filteringOptions
];

export const allFilterNames = filterOptions.map(o => o.value);
